import React, {Component} from 'react'

class DeviceAINMini extends Component {
  render() {
    const {device, unit, color} = this.props
    return <div className="box-device">
      <div className="value">
        <span className="number" style={{
            color: color
          }}>{Math.round(device.Val / 10)}</span>
        <span className="unit">{unit}</span>
      </div>
      <span style={{
          color: color
        }}>{device.Name}</span>
    </div>
  }
}

export default DeviceAINMini;



// WEBPACK FOOTER //
// ./src/components/DeviceAINMini.js